<template>
  <div>
    <span class="text-h5">{{ $t('filterConditions') }}</span>
    <v-chip class="ml-2 mb-1" color="primary">
      {{ displayedFilterConditions.length }}
    </v-chip>
    <v-list>
      <filter-condition-row
        v-for="(condition, index) in displayedFilterConditions"
        :key="index"
        :value="condition"
        :index="index"
        :column-items="safeColumnItems"
        @input="updateFilterCondition(index, $event)"
        @delete="deleteLineFilter(index)"
      />
    </v-list>
    <div class="text-right pr-4 py-4">
      <v-btn color="primary" @click="appendFilterConditions">
        <v-icon>mdi-plus</v-icon>{{ $t('add') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import FilterConditionRow from './FilterConditionRow.vue'

export default {
  name: 'LineFiltering',
  components: {
    FilterConditionRow,
  },
  props: {
    filterConditions: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    selectedColumns: {
      type: Array,
      default: () => [],
    },
    showAllColumns: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    forcedColumns() {
      const forcedColumns = new Set()
      if (!this.selectedColumns || !this.columns) return forcedColumns

      for (const filterCondition of this.filterConditions) {
        if (!filterCondition.column?.value) continue

        const isColumnSelected = this.selectedColumns.some(
          (value) => value === filterCondition.column.value
        )

        if (!isColumnSelected) {
          const additionalColumn = this.columns.find(
            ({ value }) => value === filterCondition.column.value
          )
          if (additionalColumn) {
            forcedColumns.add(additionalColumn.value)
          }
        }
      }
      return forcedColumns
    },
    safeColumnItems() {
      if (!this.columns) return []
      if (this.showAllColumns) return this.columns
      if (!this.selectedColumns) return []

      const selectedColumnsSet = new Set(this.selectedColumns)
      return this.columns.filter(
        ({ value }) =>
          selectedColumnsSet.has(value) || this.forcedColumns.has(value)
      )
    },
    displayedFilterConditions() {
      if (!this.filterConditions?.length) return []

      return this.filterConditions.map((filter) => {
        if (!filter?.column?.value) {
          return this.getEmptyFilter()
        }

        const column = this.columns.find((c) => c.value === filter.column.value)

        if (!column && filter.column) {
          return filter
        }

        return {
          ...filter,
          column: column || {},
        }
      })
    },
  },
  watch: {
    selectedColumns: {
      immediate: true,
      handler() {
        let needUpdate = false
        const updatedConditions = this.filterConditions.map((condition) => {
          if (condition.column?.id) {
            const isColumnAvailable = this.safeColumnItems.some(
              (item) => item.value === condition.column.value
            )
            if (!isColumnAvailable) {
              const column = this.columns.find(
                (c) => c.value === condition.column.value
              )
              if (column) {
                needUpdate = true
                return {
                  ...condition,
                  column: column,
                }
              }
            }
          }
          return condition
        })

        if (needUpdate) {
          this.$emit('changeFilterConditions', updatedConditions, true)
        }
      },
    },
  },
  methods: {
    appendFilterConditions() {
      const newConditions = [
        ...this.filterConditions,
        {
          column: '',
          operator: '',
          value: '',
        },
      ]
      this.$emit('changeFilterConditions', newConditions)
    },
    deleteLineFilter(index) {
      const updatedConditions = [...this.filterConditions]
      updatedConditions.splice(index, 1)
      this.$emit('changeFilterConditions', updatedConditions)
    },
    updateFilterCondition(index, newCondition) {
      const newConditions = [...this.filterConditions]
      newConditions[index] = newCondition
      this.$emit('changeFilterConditions', newConditions)
    },
    getEmptyFilter() {
      return {
        column: '',
        operator: '',
        value: '',
      }
    },
  },
}
</script>
